import appliBg from '../assets/appliBg.svg';

const TeamDisplay = () => {
  return (
    <div className="relative hidden xl:flex items-center justify-end h-full">
      <img
        src={appliBg}
        alt=""
        className="h-[280px] w-auto object-contain"
      />
      {/* Gradient fade on left edge */}
      <div
        className="absolute top-0 left-0 h-full w-[200px]"
        style={{
          backgroundImage:
            'linear-gradient(90deg, rgb(255,255,255) 0%, rgba(255,255,255,0.8) 40%, rgba(255,255,255,0) 100%)',
        }}
      />
    </div>
  );
};

export default TeamDisplay;
